<section
  class="horizontal-carousel vertical-as"
  [id]="customId"
  [style.--margin-left]="'7.36vw'"
>
  <div class="horizontal-carousel-header" *ngIf="showHeader">
    <h2 [style]="'fontSize.28' | translate">
      {{ localizedTitle }}
    </h2>
  </div>
  <ng-container *ngIf="!inAppBanner; else inAppBannerCard">
    <section
      id="horizontal-carousel-cards"
      class="horizontal-carousel-track horizontal-as horizontal-focusable-container"
      [ngClass]="'horizontal-carousel-cards-' + index"
      (keyup)="onKeyUp()"
      (keydown.ArrowLeft)="onArrowLeft()"
      (keydown.ArrowRight)="onArrowRight()"
      [ngStyle]="scrollMovement"
    >
      <ng-container
        *ngFor="
          let item of horizontalList;
          let i = index;
          trackBy: trackByIndex
        "
      >
        <section
          class="cards-container focusable-element"
          [ngClass]="'app-cards-' + i"
          [tabindex]="i"
          id="card-identifier"
          (focus)="
            onFocusCard({ index: i, resource: item, verticalIndex: index })
          "
          (click)="onClick(item)"
        >
          <div class="image-container vertical-ac">
            <div
              class="image-wrapper vertical-as"
              [ngClass]="['CARD_' + aspectRatio]"
              [style]="'fontSize.28' | translate"
              [style.margin]="'$vh-3 $vw-3'"
            >
              <img
                [src]="item?.image"
                alt="Card Image"
                class="image-placeholder"
                (error)="onImageError($event)"
                loading="lazy"
                [ngClass]="{
                  hidden: item.type === 'view-all'
                }"
              />
              <div
                class="view-all-container vertical-center"
                *ngIf="item.type === 'view-all'"
              >
                <app-icon
                  [icon]="'viewall-arrow-right'"
                  class="viewall-icon"
                ></app-icon>
                <h3 class="view-all-title" [style]="'fontSize.28' | translate">
                  {{ "view_all_title" | translate }}
                </h3>
              </div>
            </div>
          </div>

          <div
            class="progress-bar-outside"
            *ngIf="containers.sourceType === 'continue_watching'"
          >
            <div
              class="progress-bar-outside-fill"
              [style.width]="item.offset + '%'"
            ></div>
          </div>

          <div
            class="card-title"
            *ngIf="containers.sourceType === 'continue_watching'"
          >
            <h3
              [style]="'fontSize.20' | translate"
              [ngClass]="'WIDTH_' + aspectRatio"
            >
              {{ item?.title[lang] || item?.title?.en }}
            </h3>
          </div>
        </section>
      </ng-container>
    </section>
  </ng-container>
  <ng-template #inAppBannerCard>
    <app-in-app-banner
      [resource]="containers?.resources[0]"
      (keydown.ArrowLeft)="focusLeft.emit()"
      [verticalIndex]="index"
      [index]="0"
    ></app-in-app-banner>
  </ng-template>
</section>
